<template>
    <component :is="selectedComponent" v-bind="currentProperties"></component>
</template>

<script>

import AddTag from "./AddTag.vue"
import ShowTags from "./ShowTags.vue"
import TagInfo from "./TagInfo.vue"


export default {
  name: "Tags",
  data() {
    return {
      selectedComponent: ShowTags,
    };
  },
  provide() {
    return {
      changeSelectedComponent: this.changeSelectedComponent,
    };
  },
  components: {
    "add-tag": AddTag,
    "tag-info": TagInfo,
    "show-tags": ShowTags
  },
  methods: {
    changeSelectedComponent(compName) {
      this.selectedComponent = compName;
    },
    showBinsTopNav() {
      let comps = [
        "add-bin",
        "bins-info",
        "bins-watchfolder"
      ];
      if (comps.indexOf(this.selectedComponent) > -1) {
        return true;
      }
    }
  },
  computed:{
      currentProperties() {                                        //Dynamically send props
      if (this.selectedComponent === "tag-info") {
        return { selectedUserGroupID : "321123231231"};               
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>